/**
 * N-column grid.
 * @param {{ cols?: number, gap?: number, children?: any }} props
 */
export default function Grid({ cols = 2, gap = 16, children }) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))`,
        gap,
      }}
    >
      {children}
    </div>
  );
}
